var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "privacy-policy" }, [
      _c("h1", [_vm._v("Privacy Policy for VibeTap")]),
      _c("p", [
        _c("strong", [_vm._v("Effective Date:")]),
        _vm._v(" November 3, 2024"),
      ]),
      _c("p", [
        _vm._v(
          "At VibeTap, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit our website."
        ),
      ]),
      _c("h2", [_vm._v("1. Information We Collect")]),
      _c("p", [_vm._v("We may collect the following types of information:")]),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Personal Information:")]),
          _vm._v(
            " When you create an account, make a purchase, or contact us, we may collect personal information such as your name, email address, and other relevant details."
          ),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Non-Personal Information:")]),
          _vm._v(
            " This includes information such as your IP address, browser type, and pages visited, collected through cookies and similar tracking technologies."
          ),
        ]),
      ]),
      _c("h2", [_vm._v("2. Payment Data")]),
      _c("p", [
        _vm._v("We have partnered with "),
        _c("strong", [_vm._v("Stripe")]),
        _vm._v(
          " to securely handle your payment information. Stripe processes your payment data directly, and we do not store sensitive payment details on our servers. For more information on Stripe’s data practices, please refer to "
        ),
        _c(
          "a",
          { attrs: { href: "https://stripe.com/privacy", target: "_blank" } },
          [_vm._v("Stripe’s Privacy Policy")]
        ),
        _vm._v("."),
      ]),
      _c("h2", [_vm._v("3. How We Use Your Information")]),
      _c("p", [_vm._v("We may use your information to:")]),
      _c("ul", [
        _c("li", [
          _vm._v("Personalize and improve your experience on our site."),
        ]),
        _c("li", [
          _vm._v("Process transactions and provide customer support."),
        ]),
        _c("li", [
          _vm._v(
            "Send updates about your orders and relevant products or services (you may opt out at any time)."
          ),
        ]),
      ]),
      _c("h2", [_vm._v("4. Account Deletion")]),
      _c("p", [
        _vm._v(
          "You have the right to delete your account and any associated personal information at any time. To initiate this process, please contact us at "
        ),
        _c("a", { attrs: { href: "mailto:help@vibe-tap.com" } }, [
          _vm._v("help@vibe-tap.com"),
        ]),
        _vm._v(", and we will handle your request promptly."),
      ]),
      _c("h2", [_vm._v("5. Security Measures")]),
      _c("p", [
        _vm._v(
          "We implement a variety of security measures to maintain the safety of your personal information. Our practices include encrypted data transmission and access control policies to protect against unauthorized access."
        ),
      ]),
      _c("h2", [_vm._v("6. Data Sharing")]),
      _c("p", [
        _vm._v(
          "We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties, except as necessary to provide our services, comply with legal obligations, or protect our rights."
        ),
      ]),
      _c("h2", [_vm._v("7. Your Rights")]),
      _c("p", [
        _vm._v(
          "Depending on your location, you may have rights regarding your personal information, including the right to access, correct, or delete your data. Please contact us at "
        ),
        _c("a", { attrs: { href: "mailto:help@vibe-tap.com" } }, [
          _vm._v("help@vibe-tap.com"),
        ]),
        _vm._v(" to exercise these rights."),
      ]),
      _c("h2", [_vm._v("8. Child Safety")]),
      _c("p", [
        _vm._v(
          "VibeTap is committed to complying with child safety laws. Our platform is not intended for children under the age of 18, and we do not knowingly collect personal information from minors. If we become aware that we have inadvertently collected personal information from a minor, we will take immediate steps to delete that information."
        ),
      ]),
      _c("h2", [_vm._v("9. Underage Drinking Disclaimer")]),
      _c("p", [
        _vm._v(
          "VibeTap is a technology platform that provides tools for nightlife venues. We are not responsible for underage drinking or illegal activities that may occur in bars or clubs using our system. The responsibility for compliance with local laws, including those related to age restrictions, lies with the venues that use our services."
        ),
      ]),
      _c("h2", [_vm._v("10. Changes to This Privacy Policy")]),
      _c("p", [
        _vm._v(
          "VibeTap may update this Privacy Policy periodically. We encourage you to review it from time to time to stay informed of any changes."
        ),
      ]),
      _c("h2", [_vm._v("11. Contact Us")]),
      _c("p", [
        _vm._v(
          "If you have any questions about this Privacy Policy, please contact us at "
        ),
        _c("a", { attrs: { href: "mailto:help@vibe-tap.com" } }, [
          _vm._v("help@vibe-tap.com"),
        ]),
        _vm._v("."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }